function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { EnvMap } from '../helpers';
import { WKCOS } from './cos';

/**
 * @description: 仅cos上传；每个文件都必须有自己独立的上传实例（原因：分块上传）
 * 切勿使用useMemo缓存const uploader = new CosUploader()、再多次调用uploader.upload(...)时会导致this始终指向第一次
 */
var CosUploader = /*#__PURE__*/function () {
  function CosUploader(isProduction) {
    this.isProduction = isProduction;

    _defineProperty(this, "cos", void 0);

    _defineProperty(this, "baseURL", void 0);

    if (typeof this.isProduction === 'boolean') {
      this.baseURL = this.isProduction ? EnvMap.pro : EnvMap.dbg;
    } else {
      this.baseURL = this.isProduction;
    }

    this.cos = new WKCOS(this.baseURL);
  }

  var _proto = CosUploader.prototype;

  _proto.upload = function upload(options) {
    if (!options.file) {
      throw new Error('file required');
    }

    return this.cos.upload(options);
  } //取消请求
  ;

  _proto.cancel =
  /*#__PURE__*/
  function () {
    var _cancel = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.cos.cancel();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function cancel() {
      return _cancel.apply(this, arguments);
    }

    return cancel;
  }();

  return CosUploader;
}();

export { CosUploader as default };


//////////////////
// WEBPACK FOOTER
// ./~/@weike/uploader/lib/esm/cos/index.js
// module id = 355
// module chunks = 4